import I18n from 'I18n';
import UIMicroDateRange from 'UIComponents/dates/UIMicroDateRange';
import { TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, LAST_THIRTY_DAYS, LAST_THREE_MONTHS, THIS_QUARTER, LAST_QUARTER } from 'foundations-components/transitional/components/Dates';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { presetOptionResolver, toDateStringFromSimpleDate } from 'automation-ui-management/utils/dateRangeUtils';
import { getHistoryFiltersFromDateRange } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { getMinActionLogsRetentionSimpleDate, isWithinActionLogRetentionPeriod } from 'automation-ui-management/constants/DataRetention';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import { jsx as _jsx } from "react/jsx-runtime";
const VALID_PRESETS_WITH_TTL = [TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, LAST_THIRTY_DAYS, LAST_THREE_MONTHS, THIS_QUARTER, LAST_QUARTER];
const getMinRetentionValues = (min, minValidationMessage) => {
  if (min && isWithinActionLogRetentionPeriod(min)) {
    return {
      minOverride: min,
      minValidationMessageOverride: minValidationMessage
    };
  }
  return {
    minOverride: getMinActionLogsRetentionSimpleDate(),
    minValidationMessageOverride: I18n.text('automation-ui-management.dateFilter.pastRetentionDate')
  };
};
const DateRangeComponent = props => {
  const {
    shouldRenderFullComponent = false,
    tz,
    max,
    showPresets,
    value,
    minValidationMessage,
    maxValidationMessage,
    clearLabel,
    onChange,
    presets,
    use,
    min
  } = props;
  if (shouldRenderFullComponent) {
    return /*#__PURE__*/_jsx(UIDateRange, {
      tz: tz,
      min: min,
      max: max,
      onChange: onChange,
      presets: presets,
      showPresets: showPresets,
      value: value,
      minValidationMessage: minValidationMessage,
      maxValidationMessage: maxValidationMessage,
      "data-test-id": "UE-history-log-events-date-range-filter",
      clearLabel: clearLabel,
      use: use
    });
  }
  return /*#__PURE__*/_jsx(UIMicroDateRange, {
    tz: tz,
    min: min,
    max: max,
    onChange: onChange,
    presets: presets,
    showPresets: showPresets,
    value: value,
    minValidationMessage: minValidationMessage,
    maxValidationMessage: maxValidationMessage,
    "data-test-id": "UE-history-log-events-date-range-filter",
    clearLabel: clearLabel,
    use: use
  });
};
const DateRangeFilter = ({
  dateRange,
  defaultPreset,
  min,
  max,
  onFilterChange,
  minValidationMessage,
  maxValidationMessage,
  showPresets = false,
  tz = 'userTz',
  shouldRenderFullComponent,
  trackingKey = Trackables.HISTORY_FILTERS_DATE_RANGE,
  clearLabel,
  use = 'default'
}) => {
  const trackEvent = useTrackEvent();
  const handleDateRangeChange = ({
    target: {
      value
    }
  }) => {
    const dateFilters = getHistoryFiltersFromDateRange(value);
    onFilterChange(dateFilters);
    trackEvent(trackingKey, {
      filterValue: value.presetId,
      startDate: toDateStringFromSimpleDate(value.startDate),
      endDate: toDateStringFromSimpleDate(value.endDate)
    });
  };

  // We only support a TTL of 180 days for action logs
  const {
    minOverride,
    minValidationMessageOverride
  } = getMinRetentionValues(min, minValidationMessage);
  return /*#__PURE__*/_jsx(DateRangeComponent, {
    tz: tz,
    min: minOverride,
    max: max,
    onChange: presetOptionResolver(handleDateRangeChange, defaultPreset),
    presets: VALID_PRESETS_WITH_TTL,
    showPresets: showPresets,
    value: dateRange,
    minValidationMessage: minValidationMessageOverride,
    maxValidationMessage: maxValidationMessage,
    shouldRenderFullComponent: shouldRenderFullComponent,
    clearLabel: clearLabel,
    use: use
  });
};
export default DateRangeFilter;